import type { Router } from "vue-router";
import { PageEnum } from "/@/enums/pageEnum";
import { useUserStoreWithOut } from "/@/store/modules/user";

const LOGIN_PATH = PageEnum.BASE_LOGIN;

export function createPermissionGuard(router: Router) {
  const userStore = useUserStoreWithOut();
  router.beforeEach(async (to) => {
    if (to.path === "/") {
      return userStore.getHomePage;
    }

    const token = userStore.getToken;
    if (token && !userStore.getUserInfo) {
      await userStore.afterLoginAction();
      if (userStore.getUserInfo) {
        return to.fullPath;
      } else {
        await userStore.logout(false, true);
        return PageEnum.BASE_LOGIN;
      }
    }

    if (to.meta?.ignoreAuth) {
      if (to.path === LOGIN_PATH && userStore.getUserInfo) {
        return (to.query?.redirect as string) || PageEnum.HOME_PAGE;
      } else if (to.name != "PageNotFound") {
        return;
      }
    }

    if (token && !userStore.getUserInfo) {
      return (to.query?.redirect as string) || PageEnum.HOME_PAGE;
    }

    if (!token) {
      const redirectData: {
        path: string;
        replace: boolean;
        query?: Record<string, string>;
      } = {
        path: LOGIN_PATH,
        replace: true,
      };
      if (to.path) {
        redirectData.query = {
          ...redirectData.query,
          redirect: to.path,
        };
      }
      return redirectData;
    }
  });
}
